// extracted by mini-css-extract-plugin
export default {"TwoDimsListFeature":"wb_a bhf_b","TwoDimsListFeature__item":"wb_b bhf_wb","TwoDimsListFeature__item__text":"wb_c bhf_vr"};